export const MFA_METHODS = {
  NONE: null,
  CHOOSE: "choose-method",
  TOTP: "totp",
  PHONE: "phone",
};

export const Apps = {
  SCM: 'scm',
	ROTA: 'rota',
	B4C: 'b4c',
	ACADEMY: 'academy',
	CAPITAL_ADVANCE: "capital_advance",
};
